<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7421_64444)">
        <path d="M20.9896 9.25C21.2576 9.7141 21.2576 10.2859 20.9896 10.75L17.1443 17.4103C16.8764 17.8744 16.3812 18.1603 15.8453 18.1603L8.1547 18.1603C7.6188 18.1603 7.12361 17.8744 6.85566 17.4103L3.01036 10.75C2.74241 10.2859 2.74241 9.7141 3.01036 9.25L6.85566 2.58974C7.12361 2.12564 7.6188 1.83974 8.1547 1.83974L15.8453 1.83975C16.3812 1.83975 16.8764 2.12564 17.1443 2.58975L20.9896 9.25Z" stroke="#000"/>
        <line x1="12" y1="22.5" x2="12" y2="10.5" stroke="#000" stroke-linecap="round"/>
        <line x1="11.8036" y1="16.678" x2="7.7886" y2="10.9439" stroke="#000" stroke-linecap="round"/>
        <line x1="0.5" y1="-0.5" x2="7.5" y2="-0.5" transform="matrix(0.573576 -0.819152 -0.819152 -0.573576 11.5 16.8008)" stroke="#000" stroke-linecap="round"/>
    </g>
    <defs>
        <clipPath id="clip0_7421_64444">
            <rect width="24" height="24" fill="white"/>
        </clipPath>
    </defs>
</svg>
